import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FixedSizeGrid as Grid, areEqual } from 'react-window';
import { withTheme } from 'styled-components';
import AutoSizer from 'react-virtualized-auto-sizer';
import { AttachsStateContext } from 'providers/attachs-state';
import Item from '../Item';
import LazyItem from '../Item/Lazy';
import useMessageStore from 'state/messageState';

const FullscreenItem = React.memo((params) => {
    // console.dir(params);
    const
        { data, columnIndex, rowIndex, style } = params,
        { attachments, colsCount, gridGutterWidth } = data,
        idx = colsCount * rowIndex + columnIndex;
    if (idx > attachments.length - 1) {
        return null;
    }

    const
        itemData = attachments[idx],
        isDisplayable = itemData.thumb ? true : false,
        props = {
            ...itemData,
            itemIdx: idx,
            style: {
                ...style,
                top: style.top + gridGutterWidth / 2,
                left: style.left + gridGutterWidth / 2,
                height: style.height - gridGutterWidth,
                width: style.width - gridGutterWidth
            }
        };

    return isDisplayable
        ? LazyItem(props)
        : Item({ itemData: props });
}, areEqual);

FullscreenItem.displayName = 'FullScreenItemRow';

function FullScreenList(props) {
    // console.dir(props);
    const { currentBreakpoint, currentViewMode } = useContext(AttachsStateContext);
    const emlData = useMessageStore((state) => state.emlData);
    const {attachments} = emlData;
    const { data: { cols, th, tw }, name } = currentBreakpoint;
    const itemCount = attachments.length;
    // Use availabe screen width on xs devices instead of fixed cols count
    const correctedCols = (name !== 'xs') ? cols : Math.floor(window.innerWidth / tw);
    const colsCount = itemCount < correctedCols ? itemCount : correctedCols;
    const rowsCount = Math.ceil(itemCount / colsCount);
    const itemData = {
        attachments,
        colsCount,
        currentViewMode,
        gridGutterWidth: props.theme.gridGutterWidth
    };
    // added - 42px for height because there is static header
    return (
        <div className="attach-panel__box" style={{ height: 'calc(100vh - 42px)', width: '100%' }}>
            <AutoSizer className='attach-panel__autosizer'>
                {({ height, width }) => (
                    <Grid
                        className="attach-panel__grid-container"
                        columnCount={colsCount}
                        columnWidth={tw}
                        height={height}
                        rowCount={rowsCount}
                        rowHeight={th}
                        width={width}
                        itemData={itemData}
                        itemCount={itemCount}
                    >
                        {FullscreenItem}
                    </Grid>
                )}
            </AutoSizer>
        </div>
    );
}

FullScreenList.propTypes = {
    theme: PropTypes.object
};

export default withTheme(FullScreenList);
